const BasicComputerKnowEnum=[
    {value:'no',label:'No'},
    {value:'basico',label:'Basico'},
    {value:'intermedio',label:'Intermedio'},
    {value:'avanzado',label:'Avanzado'},
  ]

  export default BasicComputerKnowEnum;